module.exports = __webpack_public_path__ + "img/PACI Scan AR - 1.4e9f4836.png";